var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"head"},[_c('h1',{on:{"click":_vm.navigateHome}},[_vm._v("我的美食记后台管理")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }